import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const JC_BASE = `${getNodeServerUrl()}/jc-review`;

/**
 * Get compliance / due status for a user for a specific month/year.
 * @param {Object} params - { userCode, role, division, month, year }
 * @returns {Promise}
 */
export const getComplianceStatusApi = (params) =>
  axios.get(`${JC_BASE}/compliance-status`, { params });

/**
 * List all compliance config entries (admin).
 * @returns {Promise}
 */
export const listComplianceConfigApi = () =>
  axios.get(`${JC_BASE}/compliance-config`);

/**
 * Upsert a compliance config entry (admin).
 * @param {Object} payload - { division, role, dueDay, blockAfterDue, month, year }
 * @returns {Promise}
 */
export const upsertComplianceConfigApi = (payload) =>
  axios.put(`${JC_BASE}/compliance-config`, payload);
